import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../js/coreRuntime.mjs';
import {
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../exceptions.mjs';
import {
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charCodeAt1yspne1d8erbm as charCodeAt,
} from '../js/charSequenceJs.mjs';
import {
  substringiqarkczpya5m as substring,
  substring3saq8ornu0luv as substring_0,
} from './stringJs.mjs';
import {
  toString3o7ifthqydp6e as toString_0,
  Char19o2r8palgjof as Char,
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
} from '../Char.mjs';
import { toString30pk9tzaqopn as toString_1 } from '../Library.mjs';
import {
  isHighSurrogate11jfjw70ar0zf as isHighSurrogate,
  isLowSurrogateujxcv7hjn4ma as isLowSurrogate,
} from './charJs.mjs';
import { Companion_instanceovl8he3jiijf as Companion_instance } from '../collections/AbstractList.mjs';
import { CharSequence1ceii1xorfwh7 as CharSequence } from '../CharSequence.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var StringBuilderClass;
function StringBuilder() {
  if (StringBuilderClass === VOID) {
    class $ {
      static ug(content) {
        var $this = createThis(this);
        $this.c1_1 = content;
        return $this;
      }
      static bc(capacity) {
        return this.d1();
      }
      static x2(content) {
        return this.ug(toString(content));
      }
      static d1() {
        return this.ug('');
      }
      a() {
        // Inline function 'kotlin.js.asDynamic' call
        return this.c1_1.length;
      }
      b(index) {
        // Inline function 'kotlin.text.getOrElse' call
        var this_0 = this.c1_1;
        var tmp;
        if (0 <= index ? index <= (charSequenceLength(this_0) - 1 | 0) : false) {
          tmp = charSequenceGet(this_0, index);
        } else {
          throw IndexOutOfBoundsException().je('index: ' + index + ', length: ' + this.a() + '}');
        }
        return tmp;
      }
      c(startIndex, endIndex) {
        return substring(this.c1_1, startIndex, endIndex);
      }
      xb(value) {
        this.c1_1 = this.c1_1 + toString_0(value);
        return this;
      }
      e1(value) {
        this.c1_1 = this.c1_1 + toString_1(value);
        return this;
      }
      vg(value, startIndex, endIndex) {
        return this.wg(value == null ? 'null' : value, startIndex, endIndex);
      }
      y2() {
        var reversed = '';
        var index = this.c1_1.length - 1 | 0;
        while (index >= 0) {
          var tmp = this.c1_1;
          var _unary__edvuaz = index;
          index = _unary__edvuaz - 1 | 0;
          var low = charCodeAt(tmp, _unary__edvuaz);
          if (isLowSurrogate(low) && index >= 0) {
            var tmp_0 = this.c1_1;
            var _unary__edvuaz_0 = index;
            index = _unary__edvuaz_0 - 1 | 0;
            var high = charCodeAt(tmp_0, _unary__edvuaz_0);
            if (isHighSurrogate(high)) {
              reversed = reversed + new (Char())(high) + toString_0(low);
            } else {
              reversed = reversed + new (Char())(low) + toString_0(high);
            }
          } else {
            reversed = reversed + toString_0(low);
          }
        }
        this.c1_1 = reversed;
        return this;
      }
      vb(value) {
        this.c1_1 = this.c1_1 + toString_1(value);
        return this;
      }
      xg(value) {
        this.c1_1 = this.c1_1 + value;
        return this;
      }
      yg(value) {
        return this.wb(value.toString());
      }
      zg(value) {
        return this.wb(value.toString());
      }
      wb(value) {
        var tmp = this;
        var tmp_0 = this.c1_1;
        tmp.c1_1 = tmp_0 + (value == null ? 'null' : value);
        return this;
      }
      ah(index, value) {
        Companion_instance.u6(index, this.a());
        this.c1_1 = substring(this.c1_1, 0, index) + toString_0(value) + substring_0(this.c1_1, index);
        return this;
      }
      bh(newLength) {
        if (newLength < 0) {
          throw IllegalArgumentException().a1('Negative new length: ' + newLength + '.');
        }
        if (newLength <= this.a()) {
          this.c1_1 = substring(this.c1_1, 0, newLength);
        } else {
          var inductionVariable = this.a();
          if (inductionVariable < newLength)
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              this.c1_1 = this.c1_1 + toString_0(_Char___init__impl__6a9atx(0));
            }
             while (inductionVariable < newLength);
        }
      }
      toString() {
        return this.c1_1;
      }
      ch() {
        this.c1_1 = '';
        return this;
      }
      dh(index) {
        Companion_instance.f7(index, this.a());
        this.c1_1 = substring(this.c1_1, 0, index) + substring_0(this.c1_1, index + 1 | 0);
        return this;
      }
      wg(value, startIndex, endIndex) {
        var stringCsq = toString(value);
        Companion_instance.eh(startIndex, endIndex, stringCsq.length);
        this.c1_1 = this.c1_1 + substring(stringCsq, startIndex, endIndex);
        return this;
      }
    }
    initMetadataForClass($, 'StringBuilder', $.d1, VOID, [CharSequence()]);
    StringBuilderClass = $;
  }
  return StringBuilderClass;
}
//region block: exports
export {
  StringBuilder as StringBuildermazzzhj6kkai,
};
//endregion

//# sourceMappingURL=StringBuilderJs.mjs.map
